import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, unref as _unref, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, Fragment as _Fragment, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, renderList as _renderList, vShow as _vShow, withDirectives as _withDirectives, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-7c61f4bc"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "header-wrap" }
const _hoisted_2 = { class: "header" }
const _hoisted_3 = ["src"]
const _hoisted_4 = { class: "member-title" }
const _hoisted_5 = {
  key: 0,
  class: "recommon"
}
const _hoisted_6 = { class: "recommonBuy" }
const _hoisted_7 = { class: "member-fee" }
const _hoisted_8 = {
  key: 0,
  class: "vip-card-now-price"
}
const _hoisted_9 = { class: "vip-card-price flex-aiend" }
const _hoisted_10 = { class: "vip-card-now-price" }
const _hoisted_11 = {
  key: 0,
  class: "trialPrice",
  style: {"color":"rgb(255,77,79)"}
}
const _hoisted_12 = {
  key: 0,
  style: { fontSize: '28px' }
}
const _hoisted_13 = { key: 1 }
const _hoisted_14 = { key: 0 }
const _hoisted_15 = { class: "price" }
const _hoisted_16 = { class: "unit" }
const _hoisted_17 = { key: 1 }
const _hoisted_18 = { class: "price" }
const _hoisted_19 = { class: "unit" }
const _hoisted_20 = { key: 0 }
const _hoisted_21 = { class: "price" }
const _hoisted_22 = { class: "unit" }
const _hoisted_23 = { key: 0 }
const _hoisted_24 = { class: "price" }
const _hoisted_25 = { class: "unit" }
const _hoisted_26 = { key: 1 }
const _hoisted_27 = { class: "price" }
const _hoisted_28 = { class: "unit" }
const _hoisted_29 = { key: 0 }
const _hoisted_30 = { key: 1 }
const _hoisted_31 = { key: 2 }
const _hoisted_32 = {
  key: 0,
  class: "mt-[72px] text-black-800",
  style: {"margin-top":"72px"}
}
const _hoisted_33 = {
  key: 1,
  class: "mt_10 text-black-800"
}
const _hoisted_34 = {
  key: 2,
  class: "mt_10 text-black-800"
}
const _hoisted_35 = {
  key: 3,
  class: "mt_10 text-black-800"
}
const _hoisted_36 = { class: "member_content" }
const _hoisted_37 = {
  key: 0,
  class: "icon",
  src: "https://static-s.theckb.com/BusinessMarket/member/member_true.png",
  alt: ""
}
const _hoisted_38 = {
  key: 1,
  class: "icon",
  src: "https://static-s.theckb.com/BusinessMarket/member/member_false.png",
  alt: ""
}
const _hoisted_39 = { class: "title" }

import { t } from '@/plugins/i18n'
import { computed, ref } from 'vue'
import { CardItem } from './MemberTabs.vue'
import { getCurrentMonetaryUnit, formatCountryMoney, formatMoneyDirection, getActivePriceByStation } from '@/util/useYan'
import { isJA, useSite, isEN } from '@/store/index'
import { formatMoney } from '@/plugins/utils'
import { useStore } from 'vuex'


export default /*#__PURE__*/_defineComponent({
  props: {
    memberCardInfo: { type: null, required: true }
  },
  emits: ['open'],
  setup(__props: any, { emit }) {

const props = __props as {
  memberCardInfo: CardItem
}


const store = useStore()
const templateLevel = computed(() => {
  return store.getters.membership?.templateLevel ?? 0
})


const currentMonetaryUnit = getCurrentMonetaryUnit()
// 会员套餐信息
const combo = computed(() => props.memberCardInfo.combo)
// 新手会员标识
const newMemberFlag = computed(() => combo.value.priceItemList?.some((v) => v.trialFlag))
// 新会员信息
const newMember = computed(() => combo.value?.priceItemList?.filter((v) => v.trialFlag)[0])
console.log(newMember, 'newMember')

// 新会员提示
const newMemberTag = computed(() => {
  if (newMember.value?.trialDiscount === 0) {
    return t('新客{A}円', { A: getActivePriceByStation() })
  }
  if (newMember.value?.trialDiscount === -2) {
    return t('首月0元')
  }
  return `${t('新客{x}折', { x: String((10 - (newMember.value?.trialDiscount ?? 0)) * 10) })}`
})

return (_ctx: any,_cache: any) => {
  const _component_el_text = _resolveComponent("el-text")!

  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["card-item", `card-level-${__props.memberCardInfo?.level}`]),
    key: __props.memberCardInfo.level
  }, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        (__props.memberCardInfo?.level)
          ? (_openBlock(), _createElementBlock("img", {
              key: 0,
              class: "member-level-logo",
              src: `https://static-s.theckb.com/BusinessMarket/Client/member/member_level_${__props.memberCardInfo.level}.png`,
              alt: ""
            }, null, 8, _hoisted_3))
          : _createCommentVNode("", true),
        _createElementVNode("div", _hoisted_4, [
          _createTextVNode(_toDisplayString(_unref(combo).priceName) + " ", 1),
          (_unref(newMemberFlag))
            ? (_openBlock(), _createElementBlock("span", _hoisted_5, _toDisplayString(_unref(t)('推荐')), 1))
            : _createCommentVNode("", true)
        ]),
        _createElementVNode("div", _hoisted_6, _toDisplayString(__props.memberCardInfo.recommonBuy), 1),
        _createElementVNode("div", _hoisted_7, [
          (__props.memberCardInfo.level === 0)
            ? (_openBlock(), _createElementBlock("div", _hoisted_8, _toDisplayString(_unref(t)('免费')), 1))
            : _createCommentVNode("", true),
          _createElementVNode("div", _hoisted_9, [
            _createElementVNode("div", _hoisted_10, [
              (_unref(newMemberFlag))
                ? (_openBlock(), _createElementBlock("div", _hoisted_11, [
                    (_unref(isEN)())
                      ? (_openBlock(), _createElementBlock("span", _hoisted_12, _toDisplayString(_unref(newMemberTag)), 1))
                      : (_openBlock(), _createElementBlock("span", _hoisted_13, _toDisplayString(_unref(newMemberTag)), 1))
                  ]))
                : (__props.memberCardInfo.level > 0)
                  ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                      (_unref(isJA)())
                        ? (_openBlock(), _createElementBlock("div", _hoisted_14, [
                            _createElementVNode("span", _hoisted_15, _toDisplayString(_unref(formatMoney)(_unref(combo).discountActualPrice)), 1),
                            _createElementVNode("span", _hoisted_16, _toDisplayString(_unref(t)('{currency}/月', { currency: _unref(currentMonetaryUnit) })), 1)
                          ]))
                        : (_openBlock(), _createElementBlock("div", _hoisted_17, [
                            _createElementVNode("span", _hoisted_18, _toDisplayString(_unref(formatMoneyDirection)(_unref(combo).discountActualPrice)), 1),
                            _createElementVNode("span", _hoisted_19, _toDisplayString(_unref(t)('{currency}/月', { currency: "" })), 1)
                          ]))
                    ], 64))
                  : _createCommentVNode("", true)
            ]),
            _createVNode(_component_el_text, {
              tag: "del",
              class: "vip-card-old-price"
            }, {
              default: _withCtx(() => [
                (!_unref(newMemberFlag) && _unref(combo).discountPrice)
                  ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                      (_unref(isJA)())
                        ? (_openBlock(), _createElementBlock("div", _hoisted_20, [
                            _createElementVNode("span", _hoisted_21, _toDisplayString(_unref(formatMoney)(_unref(combo).discountPrice)), 1),
                            _createElementVNode("span", _hoisted_22, _toDisplayString(_unref(t)('{currency}/月', { currency: _unref(currentMonetaryUnit) })), 1)
                          ]))
                        : _createCommentVNode("", true)
                    ], 64))
                  : _createCommentVNode("", true),
                (_unref(newMemberFlag) && _unref(combo).discountActualPrice)
                  ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                      (_unref(isJA)())
                        ? (_openBlock(), _createElementBlock("div", _hoisted_23, [
                            _createElementVNode("span", _hoisted_24, _toDisplayString(_unref(formatMoney)(_unref(combo).discountActualPrice)), 1),
                            _createElementVNode("span", _hoisted_25, _toDisplayString(_unref(t)('{currency}/月', { currency: _unref(currentMonetaryUnit) })), 1)
                          ]))
                        : (_openBlock(), _createElementBlock("div", _hoisted_26, [
                            _createElementVNode("span", _hoisted_27, _toDisplayString(_unref(formatMoneyDirection)(_unref(combo).discountActualPrice)), 1),
                            _createElementVNode("span", _hoisted_28, _toDisplayString(_unref(t)('{currency}/月', { currency: '' })), 1)
                          ]))
                    ], 64))
                  : _createCommentVNode("", true)
              ]),
              _: 1
            })
          ])
        ]),
        (__props.memberCardInfo.level > 0)
          ? (_openBlock(), _createElementBlock("div", {
              key: 1,
              onClick: _cache[0] || (_cache[0] = ($event: any) => (emit('open', _unref(combo)))),
              class: "buy_btn"
            }, [
              (_unref(newMember)?.trialPrice === 0)
                ? (_openBlock(), _createElementBlock("span", _hoisted_29, _toDisplayString(_unref(t)('试用1个月免费')), 1))
                : (_unref(templateLevel) === 0)
                  ? (_openBlock(), _createElementBlock("span", _hoisted_30, _toDisplayString(_unref(t)('立即入会')), 1))
                  : (_unref(templateLevel) != 0)
                    ? (_openBlock(), _createElementBlock("span", _hoisted_31, _toDisplayString(_unref(templateLevel) === __props.memberCardInfo.level ? _unref(t)('去续费') : _unref(t)('去开通')), 1))
                    : _createCommentVNode("", true)
            ]))
          : _createCommentVNode("", true),
        (_unref(isJA)())
          ? (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
              (__props.memberCardInfo.level === 0)
                ? (_openBlock(), _createElementBlock("div", _hoisted_32, "個人利用や試し使いに最適なプラン"))
                : _createCommentVNode("", true),
              (__props.memberCardInfo.level === 2)
                ? (_openBlock(), _createElementBlock("div", _hoisted_33, "物販初心者〜自社ブランド展開を目指す方に最適なプラン"))
                : _createCommentVNode("", true),
              (__props.memberCardInfo.level === 3)
                ? (_openBlock(), _createElementBlock("div", _hoisted_34, "中規模の独自ブランド展開に適したプラン"))
                : _createCommentVNode("", true),
              (__props.memberCardInfo.level === 4)
                ? (_openBlock(), _createElementBlock("div", _hoisted_35, "大規模な輸入ビジネスやブランド展開を目指す方向け"))
                : _createCommentVNode("", true)
            ], 64))
          : _createCommentVNode("", true)
      ])
    ]),
    _createElementVNode("div", _hoisted_36, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.memberCardInfo.desc, (item, idx) => {
        return _withDirectives((_openBlock(), _createElementBlock("div", {
          key: idx,
          class: _normalizeClass(["member_content_item", { disabled: item.disabled }])
        }, [
          (!item.disabled)
            ? (_openBlock(), _createElementBlock("img", _hoisted_37))
            : (_openBlock(), _createElementBlock("img", _hoisted_38)),
          _createElementVNode("div", _hoisted_39, _toDisplayString(item.title), 1),
          (item.tag)
            ? _withDirectives((_openBlock(), _createElementBlock("div", {
                key: 2,
                class: "tag"
              }, _toDisplayString(_unref(t)(item.tag)), 513)), [
                [_vShow, _unref(t)(item.tag)]
              ])
            : _createCommentVNode("", true)
        ], 2)), [
          [_vShow, item.title]
        ])
      }), 128))
    ])
  ], 2))
}
}

})